import { createQueryDefinition } from 'common/services/queryBuilder';

import { searchEvents } from './services';

export const EventSearchQueryKey = createQueryDefinition(
  (query, searchBy, startDateRange) => [
    'managemobi',
    'events',
    'search',
    searchBy,
    startDateRange,
    query,
  ],
  ({ queryKey: [, , , searchBy, startDateRange, query] }) => {
    // Service throws a 500 error if search is empty
    if (!query.search) {
      return { data: [] };
    }

    // Service throws a 500 error if search is not a number when searching by ID
    if (searchBy === 'id' && !Number.isInteger(Number(query.search))) {
      return { data: [] };
    }

    return searchEvents({ searchBy, startDateRange, ...query });
  },
);
